// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductForm_wrapper__Q2w1M","container":"ProductForm_container__au7v3","action":"ProductForm_action__0COeO"};